import React from "react";
import { PackageIcon, StoreIcon } from "lucide-react";

export type DailyStoreTab = "daily" | "store";

type DailyStoreTabsProps = {
  activeTab: DailyStoreTab;
  onTabChange: (tab: DailyStoreTab) => void;
  dailyCount?: number;
  storeCount?: number;
  className?: string;
};

/** Daily = amber/orange; Store = green */
export function DailyStoreTabs({
  activeTab,
  onTabChange,
  dailyCount = 0,
  storeCount = 0,
  className = "",
}: DailyStoreTabsProps) {
  return (
    <div
      className={`flex rounded-lg border border-gray-200 bg-white p-1 shadow-sm ${className}`}
      role="tablist"
      aria-label="Daily and store orders"
    >
      <button
        type="button"
        role="tab"
        aria-selected={activeTab === "daily"}
        onClick={() => onTabChange("daily")}
        className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-md text-sm font-semibold transition-colors ${
          activeTab === "daily"
            ? "bg-amber-500 text-white shadow-sm"
            : "text-gray-600 hover:bg-amber-50"
        }`}
      >
        <PackageIcon size={18} aria-hidden />
        Daily
        <span
          className={`min-w-[1.25rem] px-1.5 py-0.5 rounded-full text-xs ${
            activeTab === "daily"
              ? "bg-amber-400 text-white"
              : "bg-gray-100 text-gray-700"
          }`}
        >
          {dailyCount}
        </span>
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={activeTab === "store"}
        onClick={() => onTabChange("store")}
        className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-md text-sm font-semibold transition-colors ${
          activeTab === "store"
            ? "bg-emerald-600 text-white shadow-sm"
            : "text-gray-600 hover:bg-emerald-50"
        }`}
      >
        <StoreIcon size={18} aria-hidden />
        Store
        <span
          className={`min-w-[1.25rem] px-1.5 py-0.5 rounded-full text-xs ${
            activeTab === "store"
              ? "bg-emerald-500 text-white"
              : "bg-gray-100 text-gray-700"
          }`}
        >
          {storeCount}
        </span>
      </button>
    </div>
  );
}
